import React from "react";
import { Star, Quote, CheckCircle } from "lucide-react";

// Real reviews from the image
const testimonials = [
  {
    name: "Kunde aus Büren",
    service: "Boiler entkalken",
    text: "Besten Dank! Die Arbeit wurde zu unserer vollsten Zufriedenheit ausgeführt! Es wurde sehr freundlich und sehr sauber gearbeitet. Solche Handwerker sollte es mehr geben!",
    stars: 5,
    date: "14.05.2026"
  },
  {
    name: "Privatperson",
    service: "Dusch WC ersetzen",
    text: "Sehr speditiv und zuverlässig. Freundlich und zuvorkommend. Arbeiten wurden zur vollsten Zufriedenheit ausgeführt.",
    stars: 5,
    date: "02.07.2026"
  },
  {
    name: "Liegenschaftsverwaltung",
    service: "Entkalkung Warmwasserboiler",
    text: "Der Sanitär ist pünktlich erschienen und hat die Entkalkung des Boilers fachgerecht durchgeführt. Die Mieter berichteten, dass die Arbeiten insgesamt reibungslos verliefen. Insgesamt sind wir mit der Ausführung zufrieden. Vielen Dank!",
    stars: 5,
    date: "05.07.2026"
  },
];

const Testimonials = () => {
  return (
    <section className="py-24 bg-gray-50" id="testimonials">
      <div className="max-w-[1600px] mx-auto px-6">
        
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="font-bold tracking-widest text-xs uppercase mb-4" style={{ color: "#ff4a4a" }}>
            REFERENZEN
          </p>
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Was unsere Kunden sagen.
          </h2>
          <p className="text-gray-500 text-lg">
            Echte Bewertungen unserer Kunden auf Fachportalen. Qualität und Sauberkeit sind unser Versprechen.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((item, index) => (
            <div 
              key={index} 
              className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 relative overflow-hidden flex flex-col"
            >
              {/* Decorative Big Quote Icon */}
              <Quote 
                className="absolute top-4 right-6 w-20 h-20 opacity-5 transform rotate-12" 
                style={{ color: "#ff4a4a" }} 
              />

              {/* Verified Badge & Date */}
              <div className="flex justify-between items-center mb-6 relative z-10">
                <div className="flex items-center gap-1 text-green-600 font-semibold text-xs uppercase tracking-wider">
                  <CheckCircle className="w-4 h-4" /> Verifizierte Bewertung
                </div>
                <span className="text-gray-400 text-xs">{item.date}</span>
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(item.stars)].map((_, i) => (
                  <Star 
                    key={i} 
                    className="w-4 h-4 fill-current" 
                    style={{ color: "#ffb400" }} // Classic Gold for stars
                  />
                ))}
              </div>

              {/* Review Text */}
              <p className="text-gray-700 text-[17px] leading-relaxed mb-8 flex-grow italic">
                "{item.text}"
              </p>

              {/* Bottom Info */}
              <div className="pt-6 border-t border-gray-50">
                <h4 className="font-bold text-gray-900 mb-1">{item.name}</h4>
                <div className="inline-block px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider bg-gray-100 text-gray-500">
                  Projekt: {item.service}
                </div>
              </div>

            </div>
          ))}
        </div>

        {/* Optional Footer (Trust factor) */}
        <div className="mt-12 text-center">
            <p className="text-sm text-gray-400 flex items-center justify-center gap-2">
                Bewertungen gesammelt via <span className="font-bold">ofri.ch</span>
            </p>
        </div>

      </div>
    </section>
  );
};

export default Testimonials;